import type { AppIconProps } from "../IconTypes";

export const RefreshIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9497 9.78075C14.8081 10.8607 14.3752 11.8818 13.6974 12.7344C13.0195 13.587 12.1224 14.239 11.1022 14.6205C10.082 15.002 8.97717 15.0986 7.90623 14.8999C6.83529 14.7013 5.83863 14.2148 5.02315 13.4927C4.20767 12.7707 3.60412 11.8402 3.27724 10.8012C2.95036 9.76223 2.91247 8.65384 3.16765 7.59494C3.42283 6.53604 3.96144 5.56658 4.72572 4.79052C5.48999 4.01446 6.45111 3.46109 7.50599 3.18975C10.4302 2.43975 13.4572 3.945 14.5747 6.75M15 2.99999V6.74999H11.25"
        stroke="#59C69E" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

